<template>
    <div>
        <div>
            <div class="row mb-8">
                <div class="col-12 col-md-4 d-flex justify-content-start">
                    <v-card-title>
                        {{ $t('routes.invoices') }}
                    </v-card-title>
                </div>
                <div class="col-12 col-md-8 d-flex justify-content-end gap-2 ">
                    <genericBtnComponent v-if="isSupplier()" :disabled="!ValidatedSupplier"
                    :ClickFun="navigateToNewInvoices" svg="2" :Title="$t('invoices.create')" />
                    <genericBtnComponent @click="openFilterDialog" svg="4" :disabled="!hasPermissionToReadInvoices"
                        Title="" class="ml-2" />
                    <genericBtnComponent @click="exportInvoices" svg="3" :disabled="!hasPermissionToExport" Title="" />
                    <genericBtnComponent @click="listInvoices" svg="5" Title="" />
                </div>

            </div>
        </div>
        <v-card flat>
            <InvoiceList ref="invoiceListRef" :hasPermissionToReadInvoices="hasPermissionToReadInvoices"
                :hasPermissionToExport="hasPermissionToExport" :showFilterDialog="showFilterDialog"
                @open-filter-dialog="openFilterDialog" />
        </v-card>
    </div>
</template>
<script>
import { isSupplier } from "@/api/index";
import InvoiceList from "./InvoiceList.vue";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import { CheckPermissionByUser } from "@/api/index";

export default {
    components: {
        InvoiceList,
        genericBtnComponent
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.invoices');
        CheckPermissionByUser("Optima.Invoices.Read")
            .then((response) => {
                this.hasPermissionToExport = response.data;
                this.hasPermissionToReadInvoices = response.data;
                if (this.hasPermissionToExport) {
                    // this.$refs.invoiceListRef.exportToExcel();
                } else {
                    // Vous n'avez pas la permission d'exporter les factures.
                }
            })
    },
    data: () => ({
        ValidatedSupplier: false,
        hasPermissionToExport: false,
        showFilterDialog: false,
        hasPermissionToReadInvoices: false,
    }),
    created() {
        this.isValidatedSupplier();
    },
    methods: {
        openFilterDialog(newValue) {
            if (this.hasPermissionToReadInvoices) {
                // this.$refs.invoiceListRef.$refs.dialogFilterInvoices.cancel();
                this.showFilterDialog = newValue;
            }
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
        exportInvoices() {
            if (this.hasPermissionToExport) {
                this.$refs.invoiceListRef.exportToExcel();
            }
        },
        listInvoices() {
            this.$refs.invoiceListRef.handleNullableFilters();
        },
        navigateToNewInvoices() {
            this.$router.push({ path: '/NewInvoice' });
        },
        isSupplier() {
            return isSupplier()
        },
        isValidatedSupplier() {
            this.ValidatedSupplier = this.isSupplier();
        }
    },
};
</script>
<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}
</style>